"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _features = require("../../../Shared/store/features");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    imageWrapper: function imageWrapper(props) {
      return {
        height: '148px',
        width: '148px',
        border: "1px solid ".concat(palette.grey.timberWolf),
        background: "url(".concat(props.img, ") no-repeat center center"),
        backgroundSize: 'contain',
        cursor: 'pointer'
      };
    }
  };
});

var MarketplaceProductListItem = function MarketplaceProductListItem(_ref2) {
  var product = _ref2.product,
      onPreview = _ref2.onPreview;
  var classes = useStyles({
    img: product.image
  });
  var multipleValues = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.MULTIPLE_GIFT_CARD_VALUES));
  var shouldShowProductPrice = !(multipleValues && product.hasRangeDenomination);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": "CreateGift-MarketplaceProduct",
    width: 148,
    m: 1.5,
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.imageWrapper,
    onClick: onPreview
  }), shouldShowProductPrice && /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 1,
    className: "Body-Regular-Left-Chambray-Bold"
  }, "$", /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, null, product.price.amount)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Body-Regular-Left-Link-Bold Text-Pointer",
    onClick: onPreview
  }, product.name), !product.hasExternalFulfillment && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Body-Small-Inactive"
  }, "from ", product.brand.name));
};

MarketplaceProductListItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  product: _propTypes.default.object.isRequired,
  onPreview: _propTypes.default.func.isRequired
};
var _default = MarketplaceProductListItem;
exports.default = _default;